import { useState, useEffect, useMemo } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import ProjectsExplorer from "../components/portal/ProjectsExplorer";

function UATProjects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const querySnapshot = await getDocs(
          collection(db, "workspaces/ai-apps-dashboard/projects")
        );
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        data.sort((a, b) => {
          if (typeof a.sequence === "number" && typeof b.sequence === "number") {
            return a.sequence - b.sequence;
          }
          const dateA = a.createdAt?.toDate?.() || new Date(0);
          const dateB = b.createdAt?.toDate?.() || new Date(0);
          return dateA - dateB;
        });
        setProjects(data);
      } catch (err) {
        console.error("Error fetching projects:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  const uatProjects = useMemo(() => {
    // Show only projects that have a UAT link field filled (including "NA")
    // Projects with "NA" will show but won't have the "Open App" icon
    return projects.filter((p) => {
      const uatLink = p.uatLink?.trim?.();
      const hasUatLinkField = uatLink && uatLink.length > 0;
      return hasUatLinkField;
    });
  }, [projects]);

  return (
    <div className="h-full overflow-hidden">
      {loading ? (
        <div className="h-full flex items-center justify-center">
          <p className="text-sm text-slate-500">Loading UAT projects...</p>
        </div>
      ) : (
        <ProjectsExplorer projects={uatProjects} mode="uat" defaultView="detail" />
      )}
    </div>
  );
}

export default UATProjects;
